<script setup lang="ts">
import { defineProps } from 'vue';
import { BaseProject } from '../../../../types/project';
import { getProjectVisibilityType } from '../../../../types/project_visibility';
import ImageIcon from '@/dashboard/vue/components/icons/ImageIcon.vue';
import LockIcon from '@/dashboard/vue/components/icons/LockIcon.vue';
import TeamIcon from '@/dashboard/vue/components/icons/TeamIcon.vue';
import FolderIcon from '@/dashboard/vue/components/icons/FolderIcon.vue';
import Dropdown from '@/dashboard/vue/components/common/Dropdown/Dropdown.vue';
import IconButton from '@/dashboard/vue/components/common/IconButton.vue';
import DirectoryContextMenuItems from '@/dashboard/vue/components/contexts/DirectoryContextMenu/DirectoryContextMenuItems.vue';
import MenuPoints from '@/dashboard/vue/components/icons/MenuPoints.vue';
import SideMenuItem from '@/dashboard/vue/components/layout/SideMenu/SideMenuItem.vue';
import InfoIcon from '@/dashboard/vue/components/icons/InfoIcon.vue';
import Tooltip from '@/dashboard/vue/components/common/Tooltip.vue';

const props = defineProps<{
  project: BaseProject;
}>();
</script>

<template>
  <SideMenuItem
    :title="props.project.name"
    :bordered="props.project.temporary"
    :hover="true"
    :path="`/d/${props.project.short_link}`"
    :class="'ml-[12px] w-full'"
    :title-class="'max-w-[100px]'"
  >
    <template #icon>
      <ImageIcon v-if="props.project.temporary" class="min-w-[16px] stroke-black dark:stroke-gray-500" />
      <LockIcon
        v-else-if="getProjectVisibilityType(props.project) == 'private'"
        :stroke-class="'stroke-black dark:stroke-gray-500'"
        :fill-class="'fill-black dark:fill-gray-500'"
        class="min-w-[16px]"
      />
      <TeamIcon v-else-if="getProjectVisibilityType(props.project) == 'team'" class="min-w-[16px] stroke-black dark:stroke-gray-500" />
      <FolderIcon v-else-if="getProjectVisibilityType(props.project) == 'link'" class="min-w-[16px] stroke-black dark:stroke-gray-500" />
    </template>
    <template #right>
      <Dropdown v-if="!props.project.temporary" :need-teleport="true" class="hidden laptop:block">
        <template #title="{ isOpen }">
          <IconButton
            :class="
              [
                'hidden !h-[24px] stroke-gray-500 hover:bg-gray-300 hover:stroke-black active:bg-gray-350 group-hover:flex dark:hover:bg-gray-800 dark:hover:stroke-gray-450 dark:active:bg-gray-850',
                { '!dark:bg-gray-800 !dark:stroke-gray-450 !flex !bg-gray-300 !stroke-black': isOpen },
              ].join(' ')
            "
            :action="() => {}"
            :active="isOpen"
            :shadow="false"
          >
            <MenuPoints />
          </IconButton>
        </template>
        <template #body>
          <DirectoryContextMenuItems :id="props.project.id" />
        </template>
      </Dropdown>
      <span v-else class="mr-xs">
        <Tooltip>
          <template #title>
            <InfoIcon class="stroke-gray-400 dark:stroke-gray-650" />
          </template>
          <template #body>
            <span class="w-[264px]">
              This is a directory only you can access, but links to captures can be shared freely
              <br /><br />
              NOTE: Each paid user has such a personal directory (Owner, Admin, Creator).
            </span>
          </template>
        </Tooltip>
      </span>
    </template>
  </SideMenuItem>
</template>
